"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MarkdownViewer = void 0;

var _react = _interopRequireDefault(require("react"));

var _Button = require("../Button");

var _utils = require("../utils");

var _withTheme = require("../../wrappers/with-theme");

var _reactMarkdownRenderer = _interopRequireDefault(require("react-markdown-renderer"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  h1 {\n    font-size: 1.875rem;\n    font-weight: 800;\n  }\n  h2 {\n    font-size: 1.5rem;\n    font-weight: 700;\n  }\n  h3 {\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MarkdownDiv = _styledComponents["default"].div(_templateObject());

var MarkdownViewer = function MarkdownViewer(_ref) {
  var markdown = _ref.markdown;
  return /*#__PURE__*/_react["default"].createElement(MarkdownDiv, {
    className: "markdown-renderer"
  }, /*#__PURE__*/_react["default"].createElement(_reactMarkdownRenderer["default"], {
    markdown: markdown
  }));
};

exports.MarkdownViewer = MarkdownViewer;

var _default = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var large = _ref2.large,
      small = _ref2.small,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "" : _ref2$className,
      children = _ref2.children,
      _onChange = _ref2.onChange,
      value = _ref2.value,
      autoFocus = _ref2.autoFocus,
      props = _objectWithoutProperties(_ref2, ["large", "small", "className", "children", "onChange", "value", "autoFocus"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      editing = _React$useState2[0],
      setEditing = _React$useState2[1],
      prev = _react["default"].useRef(false);

  var theme = (0, _withTheme.useTheme)(),
      inputTheme = theme["input".concat((0, _utils.composeOptions)({
    large: large,
    small: small
  }))];

  var _React$useState3 = _react["default"].useState({}),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      innerRef = _React$useState4[0],
      setInnerRef = _React$useState4[1],
      _React$useState5 = _react["default"].useState("10rem"),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      height = _React$useState6[0],
      setHeight = _React$useState6[1];

  _react["default"].useEffect(function () {
    if (autoFocus && innerRef.focus) {
      innerRef.focus();
      setEditing(true);
    }
  }, [autoFocus, innerRef]);

  _react["default"].useEffect(function () {
    if (innerRef.scrollHeight > innerRef.clientHeight) {
      setHeight("calc(".concat(innerRef.scrollHeight, "px + 0.25rem)"));
    }

    if (prev.current !== editing) {
      if (editing) {
        innerRef.focus();
      }

      prev.current = editing;
    }
  }, [value, editing, innerRef]);

  var clickedOutside = _react["default"].useCallback(function (e) {
    setEditing(false);
  }, []),
      _useClickOutside = (0, _utils.useClickOutside)(clickedOutside),
      _useClickOutside2 = _slicedToArray(_useClickOutside, 1),
      setNode = _useClickOutside2[0];

  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: setNode,
    tabIndex: 0,
    onFocus: function onFocus(e) {
      return setEditing(true);
    },
    onBlur: function onBlur(e) {
      return setEditing(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: editing ? "block" : "none"
    },
    className: "relative"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "absolute ml-2",
    style: {
      left: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    onClick: function onClick(e) {
      return setEditing(false);
    }
  }, "preview")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("textarea", _extends({}, props, {
    style: {
      height: height
    },
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    },
    value: value || "",
    className: "".concat(inputTheme, " ").concat(className),
    ref: (0, _utils.useSetRefs)(ref, setInnerRef),
    rows: 6
  })))), /*#__PURE__*/_react["default"].createElement(MarkdownDiv, {
    className: "markdown-renderer",
    style: {
      display: editing ? "none" : "block"
    },
    onClick: function onClick(e) {
      return setEditing(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactMarkdownRenderer["default"], {
    markdown: value || "",
    className: "".concat(inputTheme, " ").concat(className),
    style: {
      minHeight: "2rem"
    },
    options: {
      html: true
    }
  })));
});

exports["default"] = _default;